import { render, staticRenderFns } from "./viewForm.vue?vue&type=template&id=8ac4d018&scoped=true"
import script from "./viewForm.vue?vue&type=script&lang=js"
export * from "./viewForm.vue?vue&type=script&lang=js"
import style0 from "./viewForm.vue?vue&type=style&index=0&id=8ac4d018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac4d018",
  null
  
)

export default component.exports